var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { customElement, property, html, LitElement } from 'lit-element';
import './product-tile-compact';
import i18n from 'roddeh-i18n';
let ExponeaPopupBlock = class ExponeaPopupBlock extends LitElement {
    constructor() {
        super(...arguments);
        this.skus = '';
        this.exponeaProducts = [];
        this.products = [];
        this.loading = true;
        this.altshopID = '1';
        this.options = null;
        this.placement = null;
    }
    connectedCallback() {
        super.connectedCallback();
        const exponea = window.exponea;
        if (typeof exponea !== 'object' ||
            !exponea.getRecommendation ||
            typeof exponea.getRecommendation !== 'function') {
            return;
        }
        fetch('/api/exponea-block/cart-popup', {
            method: 'GET',
            credentials: 'include',
        })
            .then((response) => {
            if (!response.ok) {
                throw new Error('Unknown failure');
            }
            return response;
        })
            .then((response) => response.json())
            .then((options) => {
            this.loading = false;
            if (!options.active) {
                return;
            }
            options.callback = this.getRecommendationsCallback(options, 'cross-selling popup');
            exponea.getRecommendation(options);
        })
            .catch((err) => {
            console.error('Failed to get recommendations options', err);
        });
    }
    getRecommendationsCallback(options, placement) {
        let loaded = false;
        this.options = options;
        this.placement = placement;
        return (data) => {
            if (loaded) {
                console.debug('exponea: received recommendations twice for one element');
                return;
            }
            if (Array.isArray(data)) {
                this.exponeaProducts = data;
                this.fetchProducts();
            }
            loaded = true;
        };
    }
    fetchProducts() {
        if (this.exponeaProducts.length === 0) {
            return;
        }
        const skus = [];
        this.exponeaProducts.forEach((exponeaProduct) => {
            skus.push(exponeaProduct.product_id);
        });
        if (skus.length === 0) {
            return;
        }
        fetch(`/api/catalog/product?sku=${encodeURIComponent(skus.join(','))}`)
            .then((res) => {
            if (!res.ok) {
                throw new Error('Invalid response');
            }
            return res.json();
        })
            .then((products) => {
            if (!Array.isArray(products)) {
                products = [products];
            }
            this.products = products.slice(0, 4);
            // Trigger zdarzenia products-show, aby mechanizmy wywołujące product-list mogły sprawdzić, co
            // finalnie zostało wyświetlone
            this.dispatchEvent(new CustomEvent('products-show', {
                detail: {
                    products,
                },
                bubbles: true,
            }));
            // Zgłaszamy do Exponei event "recommendation / show"
            if (typeof window.exponea !== 'undefined' && this.options !== null && this.placement !== null) {
                const params = {
                    action: 'show',
                    variant: null,
                    item_ids: this.products.map((product) => product.sku),
                    recommendation_id: this.options.recommendationId,
                    placement: `desktop / ${this.placement}`,
                };
                window.exponea.track('recommendation', params);
                console.debug('exponea.track: ', 'recommendation', params);
            }
        })
            .catch((err) => {
            console.error('Failed to get products for listing', err);
        });
    }
    render() {
        return html `${this.products.length > 0
            ? html ` <style>
                      .exponea-cart-popup-recommendations {
                          border-top: 1px solid #e6e6e6;
                          margin-top: 2rem;
                          padding-bottom: 1rem;
                      }

                      .exponea-cart-popup-recommendations h2 {
                          font-size: 2.714rem;
                          padding: 1.786rem 0;
                          font-weight: 100;
                          margin: 0;
                      }

                      .exponea-cart-popup-recommendations-list {
                          display: grid;
                          grid-auto-rows: 1fr;
                          grid-column-gap: 10px;
                          grid-row-gap: 16px;
                          grid-template-columns: repeat(2, minmax(200px, 1fr));
                      }

                      @media only screen and (max-width: 700px) {
                          .exponea-cart-popup-recommendations-list {
                              grid-template-columns: 1fr;
                          }
                      }
                  </style>
                  <div class="exponea-cart-popup-recommendations">
                      <h2>${i18n('You may like it')}</h2>
                      <div class="exponea-cart-popup-recommendations-list">
                          ${this.products.map((product) => html `
                                  <product-tile-compact
                                      .product=${product}
                                      altshopID="${this.altshopID}"
                                      @click=${(e) => {
                // Sprawdzamy, czy kliknięto w link lub przycisk dodawania do koszyka
                let handle = false;
                let cartAdd = false;
                e.composedPath().forEach((elem) => {
                    if (elem instanceof HTMLElement &&
                        (elem.tagName === 'A' || elem.tagName === 'CART-ADD')) {
                        handle = true;
                        cartAdd = elem.tagName === 'CART-ADD';
                    }
                });
                // Trigger zdarzenia product-click, aby mechanizmy wywołujące product-list mogły sprawdzić, co
                // finalnie zostało wyświetlone
                if (handle) {
                    this.dispatchEvent(new CustomEvent('product-click', {
                        detail: {
                            product,
                            cartAdd: cartAdd,
                        },
                        bubbles: true,
                    }));
                    // Zgłaszamy do Exponei event "recommendation / click"
                    if (typeof window.exponea !== 'undefined' &&
                        this.options !== null &&
                        this.placement !== null) {
                        const params = {
                            action: 'click',
                            variant: null,
                            item_id: product.sku,
                            recommendation_id: this.options.recommendationId,
                            placement: `desktop / ${this.placement}`,
                        };
                        window.exponea.track('recommendation', params);
                        console.debug('exponea.track: ', 'recommendation', params);
                    }
                }
            }}
                                  ></product-tile-compact>
                              `)}
                      </div>
                  </div>`
            : ``}`;
    }
};
__decorate([
    property({ type: String })
], ExponeaPopupBlock.prototype, "skus", void 0);
__decorate([
    property({ type: Array })
], ExponeaPopupBlock.prototype, "exponeaProducts", void 0);
__decorate([
    property({ type: Array })
], ExponeaPopupBlock.prototype, "products", void 0);
__decorate([
    property({ type: Boolean })
], ExponeaPopupBlock.prototype, "loading", void 0);
__decorate([
    property({ type: String })
], ExponeaPopupBlock.prototype, "altshopID", void 0);
ExponeaPopupBlock = __decorate([
    customElement('exponea-popup-block')
], ExponeaPopupBlock);
export default ExponeaPopupBlock;
